module.exports = __webpack_public_path__ + "static/media/ball_2_8.1f0d1ebe.mp3";